'use strict';

exports.__esModule = true;
exports.default = '1.4.2';


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Version.js
// module id = 917
// module chunks = 213534597649335